
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchadddatasuccess = (dataview:any)=>({
    type : 'fetch_add_data_success',
    payload:dataview,
});
export const fetchdata = (uid:any,nameId:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,type:nameId,q:2};
            const apiname = orgapi.orgfeedtype;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const addfeeddata = (uid:any,nameId:any,description:any,feedbacktype:any,id:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,type:nameId,description:description,feedbacktype:feedbacktype,id:id};
            const apiname = orgapi.orgaddfeedbacks;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchadddatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

